module.exports = __webpack_public_path__ + "static/media/GU.037043f8.svg";